import { Peer } from "../Peer";

export enum PeerEvents {
  TRACK_EVENT = "trackevent",
  ADD_DATA_CHANNEL = "adddatachannel",
  SEND_CANDIDATE = "sendcandidate",
  SEND_OFFER = "sendoffer",
  SEND_ANSWER = "sendanswer",
  ON_GOT_OFFER = "ongotoffer",
  ON_GOT_ANSWER = "ongotanswer",
  DISCONNECT = "disconnect"
}

export interface WithFromRemoteId {
  from?: number;
}

export interface WithToRemoteId {
  to: number;
}

export interface SendCandidateEvent extends WithToRemoteId {
  candidate: RTCIceCandidate;
}

export interface SendOfferEvent extends WithFromRemoteId, WithToRemoteId {
  description: RTCSessionDescription | null;
}

export type SendAnswerEvent = SendOfferEvent;

export type GotOfferEvent = WithFromRemoteId & WithToRemoteId;

export type GotAnswerEvent = GotOfferEvent;

export interface TrackEvent {
  peer: Peer;
  receiver: RTCRtpReceiver;
  streams: ReadonlyArray<MediaStream>;
  track: MediaStreamTrack;
  transceiver: RTCRtpTransceiver;
}

export interface DataChannelEvent {
  peer: Peer;
  channel: RTCDataChannel;
}

export type PeerEventsType =
  | SendCandidateEvent
  | SendOfferEvent
  | SendAnswerEvent
  | GotOfferEvent
  | GotAnswerEvent
  | DataChannelEvent
  | TrackEvent;
